import { render, staticRenderFns } from "./LogBukuEvaluasi.vue?vue&type=template&id=3d05a77a"
import script from "./LogBukuEvaluasi.vue?vue&type=script&lang=js"
export * from "./LogBukuEvaluasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports